import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory();

browserHistory.listen(location => {

  location.pathname = location.pathname.replace("/r/", "/");

  try {
    window.ga('set', 'page', location.pathname + location.search);
    window.ga('send', 'pageview');
  }
  catch (exception) {
    // console.log("Page view could not be updated on GA.");
  }
  const { hash } = location;
  if (hash !== '') {
    setTimeout(
      () => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      },
      0
    );
  }
});

export default browserHistory;
